import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const GroupManagement = Loadable(lazy(() => import("features/circulationGroup/components/GroupManagement")));
const GroupIssue = Loadable(lazy(() => import("features/circulationGroup/components/GroupIssue")));
const GroupReturn = Loadable(lazy(() => import("features/circulationGroup/components/GroupReturn")));
const GroupCirculationHistory = Loadable(lazy(() => import("features/circulationGroup/components/GroupCirculationHistory")));

const routes = {
  path: "circulationGroup",
  children: [
    { path: "", element: <GroupManagement /> },
    { path: "issue", element: <GroupIssue /> },
    { path: "return", element: <GroupReturn /> },
    { path: "history", element: <GroupCirculationHistory /> },
  ],
};

export default routes;
